import { render, staticRenderFns } from "./depense.vue?vue&type=template&id=883576ce&scoped=true&"
import script from "./depense.vue?vue&type=script&lang=js&"
export * from "./depense.vue?vue&type=script&lang=js&"
import style0 from "./depense.vue?vue&type=style&index=0&id=883576ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883576ce",
  null
  
)

export default component.exports